/** @format */

import { Route, Routes } from 'react-router';
import { Home, Event } from '../Components/Home';
import Login from '../Components/Auth/Login';
import Error404 from '../Shared/Components/Errors/Error404';

import Register from '../Components/Auth/Register';
import ForgetPassword from '../Components/Auth/ForgetPassword';

const RestrictedRoutes = () => {
	// useEffect(() => {
	// 	if (pathname !== '/') return navigate('/');
	// }, []);

	return (
		<Routes>
			{/*	<Route exact path='/event/register/:id' element={<EventRegister />} />
			<Route exact path='/event/show/:id/gender' element={<SelectGender />} />
			<Route exact path='/payment/tracking' element={<PaymentTracking />} />
			<Route exact path='/id-card' element={<IDCard />} />
			<Route exact path='/id-card/show' element={<ShowIDCard />} />
			<Route
				exact
				path='/id-card/event/:eventId/user/:userId'
				element={<Show />}
	/>*/}
			<Route exact path='/' element={<Home />} />
			<Route exact path='/match/:slug' element={<Event />} />
			<Route exact path='/login' element={<Login />} />
			<Route exact path='/register' element={<Register />} />
			<Route exact path='/forget-password' element={<ForgetPassword />} />
			<Route path='*' element={<Error404 />} />
		</Routes>
	);
};

export default RestrictedRoutes;
